import { Grid2, Typography, Box, Button, Modal, Slide, } from "@mui/material"
import { memo, useMemo, useEffect, useState } from "react";
import Table from "../../components/Table"
import AddIcon from '@mui/icons-material/Add';
import {
    getInspectors,
    getOrganizations,
    getUsersData,
} from "../../api/index.js";
import Spinner from "../../components/Spinner.js";
import InspectorForm from "../../components/forms/InspectorForm.js";
import useListStyles from "../../components/styles/List.js";
import {
    inspectorLastNameHeader,
    firstNameHeader,
    addressHeader,
    cityHeader,
    countyHeader,
    postalCodeHeader,
    phoneNumberHeader,
    cellPhoneHeader,
    createdAtHeader,
    organizationHeader,
    userHeader
} from "../../components/TableHeaders.js";

const InspectorsList = () => {
    const classes = useListStyles();
    const [isLoading, setIsLoading] = useState(false);
    const [inspectors, setInspectors] = useState([]);
    const [organizations, setOrganizations] = useState([]);
    const [users, setUsers] = useState([]);
    const [isCreateOpen, setIsCreateOpen] = useState(false);
    const [isUpdateOpen, setIsUpdateOpen] = useState(false);
    const [inspectorToUpdate, setInspectorToUpdate] = useState(null);

    const fetchData = async () => {
        setIsLoading(true)
        const { inspectors } = await getInspectors();
        setInspectors(inspectors);

        const { organizations } = await getOrganizations();
        setOrganizations(organizations);

        const { users } = await getUsersData();
        setUsers(users)
        setIsLoading(false)
    }

    useEffect(() => {
        fetchData();
    }, []);


    const handleLastNameClick = (value) => {
        setIsUpdateOpen(true);
        const inspector = inspectors.find((inspector) => inspector.lastName === value)
        const inspectorToUpdate = { ...inspector };

        if (inspectorToUpdate?.organization) {
            const inspectorsOrganization = organizations.find((organization) => organization._id === inspectorToUpdate.organization);
            inspectorsOrganization ? inspectorToUpdate.organization = inspectorsOrganization.name : inspectorToUpdate.organization = null;
        }

        if (inspectorToUpdate.user) {
            const inspectorsUser = users.find((user) => user._id === inspectorToUpdate.user);
            inspectorsUser ? inspectorToUpdate.user = inspectorsUser.username : inspectorToUpdate.user = null;
        }
        setInspectorToUpdate(inspectorToUpdate);
    }

    const tableColumns = useMemo(() => [
        inspectorLastNameHeader(handleLastNameClick),
        firstNameHeader,
        addressHeader,
        cityHeader,
        countyHeader,
        postalCodeHeader,
        phoneNumberHeader,
        cellPhoneHeader,
        createdAtHeader,
        organizationHeader(organizations),
        userHeader(users),
    ])


    return (
        <>
            <Spinner open={isLoading} />
            <Modal open={isCreateOpen} onClose={() => setIsCreateOpen(false)} sx={{ display: "flex", justifyContent: "flex-end" }}>
                <Slide direction="left" in={isCreateOpen} mountOnEnter unmountOnExit>
                    <Box className={classes.modalContent}>
                        <Typography variant="h5" className={classes.modal_title}>
                            Προσθήκη Ελεγκτή
                        </Typography>
                        <InspectorForm
                            datePickerWidth="100%"
                            isCreate={true}
                            isFromList={true}
                            setIsCreateOpen={setIsCreateOpen}
                            fetchListData={fetchData} />
                    </Box>
                </Slide>
            </Modal>
            <Modal open={isUpdateOpen} onClose={() => setIsUpdateOpen(false)} sx={{ display: "flex", justifyContent: "flex-end" }}>
                <Slide direction="left" in={isUpdateOpen} mountOnEnter unmountOnExit>
                    <Box className={classes.modalContent}>
                        <Typography variant="h5" className={classes.modal_title}>
                            Επεξεργασία Ελεγκτή
                        </Typography>
                        <InspectorForm
                            datePickerWidth="100%"
                            isCreate={false}
                            isFromList={true}
                            setIsCreateOpen={setIsUpdateOpen}
                            fetchListData={fetchData}
                            fetchedInspector={inspectorToUpdate}
                            setFetchedInspector={setInspectorToUpdate}
                            inspectorId={inspectorToUpdate?._id} />
                    </Box>
                </Slide>
            </Modal>
            <Grid2 container className={classes.container} direction="column" sx={{ marginTop: "1rem", marginLeft: "3rem" }}>
                <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ width: "90%", marginBottom: "1rem" }}>
                    <Typography variant="h5" className={classes.form_title}>
                        Ελεγκτές
                    </Typography>
                    <Box>
                        <Button variant="contained" sx={{ marginRight: "0.5rem", backgroundColor: "secondary.main" }} onClick={() => window.location.assign('/print/inspectors')}>
                            PDF
                        </Button>
                        <Button variant="contained" sx={{ backgroundColor: "primary.main" }} onClick={() => setIsCreateOpen(true)}>
                            <AddIcon sx={{ mr: "0.5rem" }} />Προσθήκη Ελεγκτή
                        </Button>
                    </Box>
                </Box>
                <Table
                    data={inspectors}
                    noDataText={isLoading ? "Φόρτωση..." : "Δεν υπάρχουν εγγραφές!"}
                    columns={tableColumns}
                    defaultSorted={[{ id: "createdAt", desc: true }]}
                />
            </Grid2>
        </>
    );
}

export default memo(InspectorsList);